import React, {Fragment, useContext} from 'react'
import './nav2.css'
import ContactsIconSelected from 'Images/agents/nav-bar/contacts-icon-selected.svg'
import ShareIconSelected from 'Images/agents/nav-bar/share-icon-selected.svg'
import LearnIconSelected from 'Images/agents/nav-bar/learn-icon-selected.svg'
import SettingsIconSelected from 'Images/agents/nav-bar/settings-icon-selected.svg'
import ContactsIcon from 'Images/agents/nav-bar/contacts-icon.svg'
import ShareIcon from 'Images/agents/nav-bar/share-icon.svg'
import LearnIcon from 'Images/agents/nav-bar/learn-icon.svg'
import SettingsIcon from 'Images/agents/nav-bar/settings-icon.svg'
import CalendarIcon from 'Images/agents/quoter/calendar-icon.svg'
import MailIcon from 'Images/agents/mail.svg'
import PhoneIcon from 'Images/agents/phone.svg'
import {Text} from 'ladder/ux/typography2'
import DropdownIcon from 'Images/dropdown-icon.svg'
import LadderLogo from 'Images/logo-rungs-with-text.svg'
import ContactMailIcon from 'Images/agent-contact-mail.svg'
import DocumentIcon from 'Images/agents/document-icon.svg'
import {preferredCarrierToUwGuidelinesUrl} from 'ladder/agents/dashboard/common2'
import {Modal} from 'ladder/ux/modal2'
import {NewLink} from 'ladder/ux/link2'
import {DashboardQueryContext} from 'ladder/agents/dashboard/DashboardQueryContext'

export function BackButton({onClick}) {
  return <div
      className='agent-dashboard-back-button'
      onClick={onClick}>
    <DropdownIcon/>
  </div>
}

function NavBarItem({thisPage, currentPage, onNavigate}) {
  const isSelected = thisPage === currentPage
  let label
  let Icon
  switch (thisPage) {
    case 'contacts':
      label = 'Contacts'
      Icon = isSelected ? ContactsIconSelected : ContactsIcon
      break
    case 'share':
      label = 'Quoter'
      Icon = isSelected ? ShareIconSelected : ShareIcon
      break
    case 'learn':
      label = 'Resources'
      Icon = isSelected ? LearnIconSelected : LearnIcon
      break
    case 'settings':
    case 'settings/profile':
    case 'settings/support':
      label = 'Settings'
      Icon = isSelected ? SettingsIconSelected : SettingsIcon
      break
  }
  return <div className='nav-bar-item'>
    <div className={'vertical-item-bar' + (isSelected ? ' selected' : '')}/>
    <div className='icon-container' onClick={() => onNavigate(thisPage)}>
      <div className='padding'>
        <div className='icon-and-text'>
          <div className='name-icon'>
            <Text color={isSelected ? 'black' : '#636363'}
                  weight='600'
                  desktopSize='body-15'
                  mobileSize='body-12'>
              {label}
            </Text>
            <div className='icon'>
              <Icon/>
            </div>
          </div>
        </div>
        <div className={'horizontal-item-bar' + (isSelected ? ' selected' : '')}/>
      </div>
    </div>
  </div>
}

function AgentHelpModal({agentHelpModalVisible, setAgentHelpModalVisible, isImo}) {
  const calendlyLink = isImo ? 'calendly.com/ladder-life-agents' : 'calendly.com/d/y42-q4n-3tq/agent-support'
  const email = isImo ? 'IMOAgentHelp@ladderlife.com' : 'agents@ladderlife.com'
  const phone = isImo ? '844-427-4900' : '650-855-2614'
  return <Modal height='xl' width='m' roundedCorners title='Get in touch with an agent care rep'
                show={agentHelpModalVisible} onDismiss={() => setAgentHelpModalVisible(false)} closeable>
    <div className='agent-help-modal'>
      <Text block weight='500' textAlign='center' size='body-12'>
        Our agent care reps are available via email or Zoom if you have any questions.
      </Text>
      <div className='help-bubbles'>
        <div className='help-bubble'>
          <CalendarIcon/>
          <div className='help-modal-content'>
            <Text size='header-12'>Book a Zoom</Text>
            <NewLink href={'https://' + calendlyLink}
                     color='#336FED' size='header-13' popout underline>
              {calendlyLink}
            </NewLink>
          </div>
        </div>
        <div className='help-bubble'>
          <MailIcon/>
          <div className='help-modal-content'>
            <Text size='header-12'>Send us an email</Text>
            <NewLink href={'mailto:' + email}
                     color='#336FED' size='header-13' popout underline>
              {email}
            </NewLink>
          </div>
        </div>
        <div className='help-bubble'>
          <PhoneIcon/>
          <div className='help-modal-content'>
            <Text size='header-12'>Give us a call</Text>
            <Text color='#336FED' size='header-13'>
              {phone}
            </Text>
          </div>
        </div>
      </div>
    </div>
  </Modal>
}

function NavBar({pages, currentPage, onNavigate, setAgentHelpModalVisible}) {
  const q = useContext(DashboardQueryContext)
  return <div className='nav-bar'>
    <div className='button-container'>
      <div className='logo-container'>
        <LadderLogo/>
      </div>
      <div className='uw-guidelines-box'>
        <DocumentIcon/>
        <a target='_blank' href={preferredCarrierToUwGuidelinesUrl(q['agent/preferred-carrier'])}>
          <Text block style={{marginLeft: '4px'}}
                fontSize='12px' lineHeight='15px' weight='bold'>
            Underwriting guidelines
          </Text>
        </a>
      </div>
      <div className='nav-items'>
        {pages.map(page => (<NavBarItem thisPage={page}
                                        currentPage={currentPage}
                                        onNavigate={onNavigate}/>))}
      </div>
    </div>
    <div className='help-container'
         onClick={() => setAgentHelpModalVisible(true)}>
      <ContactMailIcon/>
      <Text block size='body-15' color='#8E8E8E'>
        Have a question?
      </Text>
    </div>
  </div>
}

export function NavBarAndHelpModal(props) {
  return <Fragment>
    <NavBar {...props}/>
    <AgentHelpModal {...props}/>
  </Fragment>
}
